<template>
  <div class="workbench">
    <div class="promotion-banner">
      <div class="promotion-main">
        <span class="promotion-title">&#27599;&#22825;&#19979;&#21333;&#36798;&#26631;&#65292;&#21363;&#39046;10&#20803;</span>
        <span class="promotion-detail">&#35814;&#24773; <Icon type="ios-arrow-forward" /></span>
      </div>
      <div class="promotion-progress">
        <span class="progress-dot"></span>
        <span class="progress-line"></span>
        <span class="progress-dot"></span>
      </div>
      <div class="promotion-reward">
        <span class="gift-icon">&#127873;</span>
        <span>10&#20803;&#20248;&#24800;&#21048;&#31036;&#21253;</span>
      </div>
      <div class="promotion-countdown">&#21097;21&#22825; 14:20:46</div>
    </div>
    <div style="display: flex;justify-content: space-between">
      <UserCard></UserCard>
      <CapitalCard></CapitalCard>
    </div>
    <OrderCard></OrderCard>

    <orderItem
      :order_no="item.number"
      :product_img="item.product_img"
      :status_name="item.status_name"
      :created_at="item.created_at"
      :phone="item.phone"
      :address="item.address"
      :contact="item.contact"

      :service_name="item.service_name"
      :product_class="item.product_class"
      :product_number="item.product_number"
      :order_type="item.order_type"
      :price="item.price"
      :show_offer="getShowOffer(item)"
      :status="item.status"
      :id="item.id"
      v-for="(item,i) in orderData"
      :key="i"></orderItem>

  </div>
</template>

<script>
import UserCard from './components/userCard'
import OrderCard from './components/order/order'
import CapitalCard from './components/capital/capital'
import orderItem from '../order/components/order-item'
export default {
  components: { UserCard, OrderCard, CapitalCard, orderItem },
  name: 'workbench',
  data () {
    return {
      orderData: []
    }
  },
  created () {
    let vm = this
    vm.getOrder()
  },
  methods: {
    getShowOffer (order) {
      const offer = Array.isArray(order.offer_info) ? order.offer_info[0] : null
      if (offer && offer.show_offer !== undefined && offer.show_offer !== null && offer.show_offer !== '') {
        return offer.show_offer
      }
      return 0
    },
    getOrder () {
      let vm = this
      console.log(vm.searFrom)
      this.$request('6182826d5d0aa', {
        page: 1,
        limit: 10
        // type:vm.searFrom.type.toString(),
        // start_time:vm.searFrom.start_time,
        // end_time:vm.searFrom.end_time
      }).then(res => {
        // vm.tableShow.listCount = res.data.count
        vm.orderData = res.data.data
        // vm.tableData = res.data.data
        // vm.tableShow.listCount = res.data.count
        console.log('-----')
        console.log(vm.orderData)
      })
    }
  }
}
</script>

<style scoped lang="less">
.workbench {
  padding: 10px;

  .promotion-banner {
    position: relative;
    height: 76px;
    margin-bottom: 14px;
    overflow: hidden;
    border-radius: 2px;
    background: linear-gradient(100deg, #ffe1bd 0%, #ffbd83 48%, #ffe9e1 100%);
    color: #f45123;

    &::before,
    &::after {
      position: absolute;
      width: 260px;
      height: 150px;
      border: 1px solid rgba(255, 255, 255, 0.65);
      border-radius: 50%;
      content: '';
    }

    &::before {
      top: -115px;
      left: -85px;
      transform: rotate(-20deg);
    }

    &::after {
      right: -100px;
      bottom: -120px;
      transform: rotate(-20deg);
    }

    .promotion-main {
      position: absolute;
      top: 8px;
      left: 50%;
      z-index: 1;
      display: flex;
      align-items: center;
      transform: translateX(-50%);
      white-space: nowrap;
    }

    .promotion-title {
      padding: 5px 48px;
      border-radius: 0 0 18px 18px;
      background: linear-gradient(90deg, #ff8b24, #ff4e1f);
      color: #fff;
      font-size: 13px;
      font-weight: 600;
    }

    .promotion-detail {
      margin-left: -45px;
      padding-left: 55px;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
    }

    .promotion-progress {
      position: absolute;
      top: 42px;
      left: 31%;
      width: 38%;
      display: flex;
      align-items: center;
    }

    .progress-line {
      height: 5px;
      flex: 1;
      background: repeating-linear-gradient(90deg, #ff7620 0 8px, #ffd04d 8px 13px);
    }

    .progress-dot {
      width: 10px;
      height: 10px;
      border: 2px solid #fff;
      border-radius: 50%;
      background: #ffae21;
    }

    .promotion-reward {
      position: absolute;
      top: 38px;
      left: 63%;
      z-index: 1;
      display: flex;
      align-items: center;
      color: #f45123;
      font-size: 13px;
      font-weight: 600;
    }

    .gift-icon {
      margin-right: 5px;
      font-size: 25px;
    }

    .promotion-countdown {
      position: absolute;
      top: 7px;
      right: 24%;
      z-index: 1;
      padding: 3px 8px;
      border: 1px solid #ff9e91;
      border-radius: 12px;
      background: #fff1eb;
      color: #f66a54;
      font-size: 11px;
    }
  }

}
</style>
